import { render } from "./GenericFormComponent.vue?vue&type=template&id=5df24be5&ts=true"
import script from "./GenericFormComponent.vue?vue&type=script&lang=ts"
export * from "./GenericFormComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__